



















import Vue from "vue";
import { uniqueLabel } from "@/helpers";

export default Vue.extend({
  name: "TextInput",

  props: {
    value: { type: String, required: true },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
  },

  data() {
    return {
      inputValue: this.value,
      id: uniqueLabel(this.label),
    };
  },
});
